// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-owner-header[data-v-d92bf78c]{font-size:18px;margin-bottom:5px}\n", ""]);
// Exports
module.exports = exports;
